import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { Observable, Subscription } from 'rxjs';
import { map, take, filter } from 'rxjs/operators';

import { CmsContent, CmsTarget } from '@fcom/core-api';
import { unsubscribe } from '@fcom/core/utils';
import { DataCloudService } from '@fcom/common/datacloud';

import { toLinkData } from '../../services';

const ALL_DESTINATIONS_LINK_MASTER_CONTENT_ID = 1239748;

@Component({
  selector: 'cms-text-link',
  template: `
    <fin-text-link
      class="mr-large-b block"
      [target$]="cmsTarget$"
      [teaserTitle$]="content$ | finMap: 'teaserTitle'"
      [colorClass]="colorClass"
      (click)="onClick()"
    ></fin-text-link>
  `,
  standalone: false,
})
export class CmsTextLinkComponent implements OnInit, OnDestroy {
  @Input()
  content$: Observable<CmsContent>;
  @Input()
  colorClass: string;

  cmsTarget$: Observable<CmsTarget>;

  private subscription: Subscription = new Subscription();

  constructor(private dataCloudService: DataCloudService) {}

  ngOnInit(): void {
    this.cmsTarget$ = this.content$.pipe(map((d) => toLinkData(d.target)));
  }

  ngOnDestroy(): void {
    this.subscription = unsubscribe(this.subscription);
  }

  onClick(): void {
    this.subscription.add(
      this.content$
        .pipe(
          take(1),
          filter((content) => content.masterContentId === ALL_DESTINATIONS_LINK_MASTER_CONTENT_ID)
        )
        .subscribe(() => {
          this.dataCloudService.destinationListAllDestinationsClick();
        })
    );
  }
}
